import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  backdrop: {
    zIndex: Theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(255,255,255, 0.75)',
    display: 'flex',
    flexDirection: 'column',
  },
  bgSolidWhite: {
    backgroundColor: 'rgba(255,255,255, 1)',
  },
  loaderContainer: {
    position: 'relative',
  },
  loaderLogo: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-21px',
    marginLeft: '-21px',
    animation: `$fadeLogo 1200ms infinite ${Theme.transitions.easing.easeInOut}`,
  },
  loaderTitle: {
    textAlign: 'center',
    fontSize: `${Theme.typography.size[4]} !important`,
    fontFamily: `${Theme.typography.proxima.regular} !important`,
    color: `${Theme.palette.primary.light} !important`,
    background: 'transparent',
    position: 'absolute',
    bottom: '-50px',
    width: 'max-content',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',

    '& p': {
      fontSize: `${Theme.typography.size[4]} !important`,
      fontFamily: `${Theme.typography.proxima.semiBold} !important`,
      color: `${Theme.palette.primary.dark} !important`,
    },
  },
  customLoaderTitle: {
    bottom: '10px !important',
    color: `${Theme.palette.primary.main}`,
  },
  circularLoader: {
    color: Theme.palette.primary.dark,
  },
  '@keyframes fadeLogo': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  '@keyframes fadeIn': {
    '0%': { opacity: '0' },
    to: { opacity: '1' },
  },
}));

export default useStyles;
